import ActivityLoader from "components/atoms/ActivityLoader/ActivityLoader"

type FullscreenStateProps = {
    children: React.ReactNode
    className?: string
    backgroundImage?: string
}

export function EventRouteFullscreenState({
    children,
    className = "",
    backgroundImage,
}: FullscreenStateProps) {
    return (
        <div
            className={className}
            style={
                backgroundImage
                    ? {
                          backgroundImage: `url("${backgroundImage}")`,
                          backgroundSize: "cover",
                          backgroundPosition: "center center",
                          backgroundRepeat: "no-repeat",
                          backgroundAttachment: "fixed",
                      }
                    : undefined
            }
        >
            {children}
        </div>
    )
}

export function EventRouteFullscreenLoader({
    className = "h-screen w-screen bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center",
    backgroundImage,
}: {
    className?: string
    backgroundImage?: string
}) {
    return (
        <EventRouteFullscreenState
            className={className}
            backgroundImage={backgroundImage}
        >
            <ActivityLoader />
        </EventRouteFullscreenState>
    )
}

export function EventRouteFullscreenError({
    title,
    description,
    onRetry,
    onBack,
    backLabel = "Back",
    retryLabel = "Try Again",
    className = "h-screen w-screen bg-cover bg-center flex flex-col items-center justify-center",
    backgroundImage,
}: {
    title: string
    description: string
    onRetry: () => void
    onBack: () => void
    backLabel?: string
    retryLabel?: string
    className?: string
    backgroundImage?: string
}) {
    return (
        <EventRouteFullscreenState
            className={className}
            backgroundImage={backgroundImage}
        >
            <div className="bg-black bg-opacity-70 p-8 rounded-xl max-w-md text-center">
                <h2 className="text-white text-xl mb-4">{title}</h2>
                <p className="text-gray-300 mb-6">{description}</p>
                <div className="flex justify-center gap-4">
                    <button
                        className="bg-mint-green-500 hover:bg-mint-green-600 text-white px-6 py-3 rounded-full"
                        onClick={onRetry}
                    >
                        {retryLabel}
                    </button>
                    <button
                        className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-full"
                        onClick={onBack}
                    >
                        {backLabel}
                    </button>
                </div>
            </div>
        </EventRouteFullscreenState>
    )
}

export function EventRouteInlineLoader({
    minHeightClassName = "min-h-[60vh]",
}: {
    minHeightClassName?: string
}) {
    return (
        <div className="wrapper">
            <div className={`flex items-center justify-center ${minHeightClassName}`}>
                <ActivityLoader />
            </div>
        </div>
    )
}
